import { Pipe, PipeTransform } from '@angular/core';
import { DateUtil } from '../util/date.util';

@Pipe({
  name: 'fancyMonthYear'
})
export class FancyMonthYearPipe implements PipeTransform {

  transform(value: number) {
    if (value != null && value > 0) {
      let date = new Date(value);
      return DateUtil.getMonthString("" + (date.getMonth() + 1)) + " " + date.getFullYear();
    } else {
      return "0";
    }
  }

}
